module.exports = __webpack_public_path__ + "img/sign_success.8ca1664f.svg";